export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "en-US",
    "Messages": {
        "Administracja": "Administration",
        "Administratorzy": "Administrators",
        "Adres e-mail potwierdzony": "Email address confirmed",
        "Aktywacja kont po rejestracji": "Account activation after registration",
        "Aktywne": "Active",
        "Aktywni": "Active",
        "Archiwizuj": "Archive",
        "Asystent AI": "AI Assistant",
        "Autor szkolenia": "Training author",
        "Azure": "Azure",
        "Banery": "Banners",
        "Baza dokumentów": "Document database",
        "Baza ogłoszeń": "Announcement database",
        "Baza PDF": "PDF database",
        "Blokada konta do": "Account lock until",
        "Błąd w kolumnie ${error.columnName} w wierszu ${error.actualRow} - ${error.error}": "Error in column ${error.columnName} in row ${error.actualRow} - ${error.error}",
        "Brak kategorii": "No category",
        "Chat z raportami szkoleń": "Chat with training reports",
        "Cykliczne": "Recurring",
        "Czy opublikowany": "Published",
        "Data dodania": "Date added",
        "Data modyfikacji": "Modification date",
        "Data rejestracji": "Registration date",
        "Dodaj szkolenie": "Add training",
        "Dodaj użytkownika": "Add user",
        "Dostęp ": "Access ",
        "Dostęp do": "Access to",
        "Dostęp od": "Access from",
        "Działania masowe": "Bulk actions",
        "E-learning": "E-learning",
        "E-mail": "E-mail",
        "Edytuj": "Edit",
        "Eksport": "Export",
        "Email": "Email",
        "Email potwierdzony": "Email confirmed",
        "Erecruiter": "Erecruiter",
        "Facebook": "Facebook",
        "Forum": "Forum",
        "Funkcjonalności AI": "AI features",
        "Gazetka": "Newsletter",
        "Google": "Google",
        "Hasło": "Password",
        "Imię": "First name",
        "Imię i Nazwisko": "First and Last Name",
        "Import": "Import",
        "Import szkoleń": "Training import",
        "Import użytkowników": "User import",
        "Indywidualny": "Individual",
        "Indywidualny z terminu spotkań": "Individual from meeting dates",
        "Inspekcja": "Inspection",
        "Kategoria": "Category",
        "Komentarze": "Comments",
        "Konto aktywne": "Active account",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "Account will remain inactive until email address is confirmed",
        "Konto z dostępem do panelu": "Account with access to panel",
        "Konto zanonimizowane": "Anonymized account",
        "Kreator Szkoleń AI": "AI Training Creator",
        "Ldap": "Ldap",
        "Liczba zaimportowanych użytkowników: ${importInformations?.importedAccounts}": "Number of imported users: ${importInformations?.importedAccounts}",
        "Lider/koordynator dla wszystkich zespołów": "Leader/coordinator for all teams",
        "Linki wewnętrzne": "Internal links",
        "Lokalne": "Local",
        "Marketing": "Marketing",
        "Moduły": "Modules",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Ability to modify this account is limited. Inactive fields are synchronized with external database %0.",
        "Narzędzia AI": "AI tools",
        "Nazwa stanowiska": "Job title",
        "Nazwa szkolenia": "Training name",
        "Nazwa użytkownika": "Username",
        "Nazwisko": "Last name",
        "Nie": "No",
        "Nie można usunąć swojego konta.": "You cannot delete your own account.",
        "Nie udało się pobrać listy ról": "Failed to retrieve role list",
        "Nie udało się pobrać listy stanowisk": "Failed to retrieve position list",
        "Nie udało się pobrać listy zespołów do których jest przypisany użytkownik": "Failed to retrieve list of teams assigned to user",
        "Nie zdefiniowano żadnych ról.": "No roles defined.",
        "Nieaktywni": "Inactive",
        "Nieopublikowane": "Unpublished",
        "Niepotwierdzeni": "Unconfirmed",
        "Niepubliczne": "Private",
        "Nieudane logowania": "Failed login attempts",
        "Numer pracownika": "Employee number",
        "Numer telefonu": "Phone number",
        "Numer telefonu komórkowego": "Mobile phone number",
        "Oferty pracy - Import": "Job offers - Import",
        "Ogólne": "General",
        "Ok": "Ok",
        "OpenAI": "OpenAI",
        "Opublikowane": "Published",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "After selecting this option, individual privileges and privileges inherited from roles are not taken into account.",
        "Podgląd": "Preview",
        "Pole \"Email\" jest wymagane.": "Field \"Email\" is required.",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "Field \"Username\" is required.",
        "Pole nie może zawierać spacji": "Field cannot contain spaces",
        "Polubienia": "Likes",
        "Potwierdzenie archiwizacji": "Archive confirmation",
        "Potwierdzenie przywrócenia szkolenia": "Training restore confirmation",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Powrót": "back",
        "Powtórz hasło": "Repeat password",
        "Pozostałe": "Other",
        "Pozycja": "Position",
        "Przefiltrowani użytkownicy": "Filtered users",
        "Przywróć": "Restore",
        "Publiczne": "Public",
        "Ranga": "Rank",
        "Raporty": "Reports",
        "Regulaminy": "Terms and conditions",
        "Rezerwacja zasobów": "Resource booking",
        "Rola": "Role",
        "Role użytkownika": "User roles",
        "Rotatory opinii": "Opinion rotators",
        "RSS": "RSS",
        "Spotkania": "Meetings",
        "Stan": "State",
        "Stanowisko pracy": "Workstation",
        "Stanowisko zostało dodane.": "Position has been added.",
        "Stanowisko zostało zaktualizowane.": "Position has been updated.",
        "Status": "Status",
        "Strona": "Page",
        "Subskrypcje": "Subscriptions",
        "Synchronizacja użytkowników": "User synchronization",
        "System": "System",
        "Szablon importu": "Import template",
        "Szkolenia": "Training",
        "Szkolenie zostało przywrócone.": "Training has been restored.",
        "Szkolenie zostało zarchiwizowane.": "Training has been archived.",
        "Szkolenie zostało zarchiwizowane. Aby je wyświetlić, należy przywrócić szkolenie z archiwum.": "Training has been archived. To display it, restore training from archive.",
        "Ta opcja dodaje użytkownika do wszystkich zespołów z zaznaczoną opcją Lidera i pozwala koordynatorowi widzieć wszystko w profilu koordynatora. Również do nowo utworzonych zespołów będzie  on ustawiał się jako Lider.": "This option adds user to all teams with Leader option selected and allows coordinator to see everything in coordinator profile. Also, in newly created teams, he will be set as Leader.",
        "Tak": "Yes",
        "Tokeny": "Tokens",
        "Top tematy": "Top topics",
        "Typ": "Type",
        "Typ konta": "Account type",
        "Uprawnienia": "Privileges",
        "Ustawienia": "Settings",
        "Ustawienia generowania streszczeń": "Summary generation settings",
        "Ustawienia konta": "Account settings",
        "Usuń": "delete",
        "Użytkownik nie będzie otrzymywał żadnych powiadomień.": "User will not receive any notifications.",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "User cannot log in until account is active.",
        "Użytkownik posiada pełne uprawnienia": "User has full privileges",
        "Użytkownik został dodany.": "User has been added.",
        "Użytkownik został usunięty.": "User has been deleted.",
        "Użytkownik został zaktualizowany.": "User has been updated.",
        "Widoczność konta": "Account visibility",
        "Wiersz ${error.actualRow}: błąd w kolumnie ${error.columnName} - ${error.error}": "Row ${error.actualRow}: error in column ${error.columnName} - ${error.error}",
        "Wszyscy użytkownicy": "All users",
        "Wszystkie": "All",
        "Wybierz przełożonego": "Select supervisor",
        "Wyłączone wysyłanie powiadomień": "Notifications sending disabled",
        "Wymuś zmianę hasła": "Force password change",
        "Wystąpił błąd archiwizacji": "An archiving error occurred",
        "Wystąpił błąd podczas próby exportu użytkowników.": "An error occurred while exporting users.",
        "Wystąpił błąd podczas próby importu szkoleń.": "An error occurred while importing training.",
        "Wystąpił błąd podczas próby importu użytkowników.": "An error occurred while importing users.",
        "Wystąpił błąd podczas próby pobrania szablonu.": "An error occurred while downloading template.",
        "Wystąpił błąd podglądu": "Preview error occurred",
        "zacznij pisać aby wyszukać przełożonego...": "start typing to search for supervisor...",
        "Zaimportowano listę użytkowników.": "User list has been imported.",
        "Zaimportowano szkolenia.": "Training has been imported.",
        "Zamknij": "Close",
        "Zamknij i pobierz": "Close and download",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and go back",
        "Zarchiwizowane": "Archived",
        "Zastępstwa": "Substitutions",
        "Zdjęcie użytkownika": "User photo",
        "Zespoły": "Teams",
        "Zespół": "Team",
        "Zwykłe": "Regular"
    }
};
